import axios from "axios";
import { axiosOmniConfig } from "@/config";
import { isObject } from "lodash";
const map = {
  platform: import.meta.env.VITE_APP_URL,
  damcorp: import.meta.env.VITE_DAMCORP_URL,
  bawaslu: import.meta.env.VITE_BAWASLU_URL,
  "pgd-omni": import.meta.env.VITE_PEGADAIAN_URL,
};

const urlTemp = map[window.location.hostname.split(".")[0]];
const httpClientOmni = axios.create(axiosOmniConfig);

const requestHandler = (r) => {
  return r;
};

const responseHandler = (r) => {
  return r;
};

const errorHandler = (e) => {
  if (isObject(e)) {
    // Handle network errors and timeouts (no response)
    if (!e.response) {
      if (e.code === "ECONNABORTED" || e.message?.includes("timeout")) {
        console.error("Request timeout or connection error:", e.message);
        // Reject with a user-friendly error
        return Promise.reject(new Error("Request timeout. Please try again."));
      }
      // Network error (browser hanging)
      console.error("Network error:", e.message);
      return Promise.reject(new Error("Network error. Please check your connection and try again."));
    }

    // Handle HTTP error responses
    const status = e.response?.status;
    
    if (status === 401) {
      localStorage.removeItem("user");
      console.log("urltemp", urlTemp);
      console.log("urlsplit", window.location.hostname.split(".")[0]);
      window.location.href = urlTemp;
      return Promise.reject(e);
    }

    // Handle 502 Bad Gateway (server error)
    if (status === 502 || status === 503 || status === 504) {
      console.error(`Server error ${status}:`, e.response?.data || e.message);
      // Reject with a user-friendly error to prevent browser hanging
      const errorMessage = status === 502 
        ? "Service temporarily unavailable. Please try again later."
        : "Server is temporarily unavailable. Please try again later.";
      return Promise.reject(new Error(errorMessage));
    }
  }
  return Promise.reject(e);
};

httpClientOmni.interceptors.request.use(
  (r) => requestHandler(r),
  (e) => errorHandler(e)
);

httpClientOmni.interceptors.response.use(
  (r) => responseHandler(r),
  (e) => errorHandler(e)
);

export default httpClientOmni;
